/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Submit_BlockedInputs */

const vi_stock_out_submit_blocked = /** @type {(inputs: Stock_Out_Submit_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa xuất kho được: còn dòng chưa chọn đủ lô. Kiểm tra các dòng báo đỏ ở trên — nếu kho đã hết, cần nhập kho trước hoặc sửa đơn bỏ mặt hàng đó.`)
};

/**

* @param {Stock_Out_Submit_BlockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_submit_blocked = /** @type {((inputs?: Stock_Out_Submit_BlockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Submit_BlockedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_submit_blocked(inputs)
});